<template>
    <div>
        <Modal title="填写订单信息" v-model="modalShow" width="720px" @on-cancel="onCancel">
            <Form ref="formValueRef" :model="formData" inline :rules="ruleValidate" :label-width="120">
                <FormItem label="联系人" prop="linkman">
                    <Input v-model="formData.linkman" clearable placeholder="请输入" style="width:200px"></Input>
                </FormItem>
                <FormItem label="联系人手机号" prop="mobile">
                    <Input v-model="formData.mobile" clearable placeholder="请输入" style="width:200px"></Input>
                </FormItem><br>
                <FormItem label="公司名称" prop="corpName">
                    <Input v-model="formData.corpName" clearable placeholder="请输入" style="width:200px"></Input>
                </FormItem>
                <FormItem label="数量" prop="quantity">
                    <InputNumber v-model="formData.quantity" :min="1" clearable placeholder="请输入" style="width:200px"></InputNumber>
                </FormItem><br>
                <FormItem label="配送方式" prop="shippingMethod">
                    <Select v-model="formData.shippingMethod" style="width:200px">
                        <Option v-for="item in deliveryOptions" :value="item.value" :key="item.value">{{ item.text }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="期望到货日期" prop="expectedReceiveDate">
                    <DatePicker type="date" placeholder="请选择" @on-change="onDateTime" style="width: 200px"></DatePicker>
                </FormItem>
                <br>
                <FormItem label="收货地址">
                    <addr-cascader v-model="formData.areaId" style="width:200px" />
                </FormItem><br>
                <FormItem label="详细地址">
                    <Input type="textarea" v-model="formData.addr" clearable style="width:530px"></Input>
                </FormItem>
            </Form>

            <div slot="footer">
                <Button type="warning" :loading="loading" @click="onSubmit">提交</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { phoneNumRegx, chineseRegx } from '@/libs/constant/regx-const.js'

import addrCascader from '_c/select/addr-cascader.vue'
export default {
    components: {
        addrCascader
    },
    data() {
        return {
            modalShow: false,
            loading: false,
            deliveryOptions: [
                { text: '配送上门', value: 'Y' },
                { text: '货物自提', value: 'N' },
            ],
            formData: {
                productId: "",
                corpName: "",
                quantity: null,
                linkman: "",
                mobile: "",
                areaId: "",
                addr: "",
                expectedReceiveDate: "",
                shippingMethod:""
            },
            minPurchaseQty: "",
            ruleValidate: {
                linkman: [{ required: true, message: "请输入联系人", }, { pattern: chineseRegx, message: "请输入中文名称" }],
                mobile: [{ required: true, message: "请输入联系人手机号" }, { pattern: phoneNumRegx, message: "请输入正确手机号" }],
                corpName: [{ required: true, message: '请输入公司名称' }],
                quantity: [{ required: true, message: "请输入数量" }],
                expectedReceiveDate:[{required:true,message:"请选择期望到货日期"}],
                shippingMethod:[{required:true,message:'请选择配送方式'}]
            }
        }
    },
    methods: {

        openModal(data) {
            console.log(data)
            this.formData.productId = data.productId;
            this.formData.areaId = data.areaId;
            this.formData.quantity = data.quantity;
            this.minPurchaseQty = data.minPurchaseQty;
            this.formData.shippingMethod = data.deliveryMethod
            this.modalShow = true;
        },
        onDateTime(val) {
            this.formData.expectedReceiveDate = val;
        },
        onCancel() {
            this.modalShow = false;
            this.$refs['formValueRef'].resetFields();
            this.formData.areaId = "";
            this.formData.addr = "";
        },
        onSubmit() {
            this.$refs['formValueRef'].validate((valid) => {
                if (valid) {
                    if (this.formData.quantity < this.minPurchaseQty) {
                        return this.$Message.warning(`最小起购数量${this.minPurchaseQty}`);
                    }

                    let data = {
                        url: "MID-CLIENT-MALL/messageService/orderService/addPalletBankOrder",
                        body: {
                            order: {
                                linkman: this.formData.linkman,
                                mobile: this.formData.mobile,
                                corpName: this.formData.corpName,
                                areaId: this.formData.areaId,
                                addr: this.formData.addr,
                                expectedReceiveDate: this.formData.expectedReceiveDate,
                                shippingMethod:this.formData.shippingMethod
                            },
                            orderProduct: {
                                productId: this.formData.productId,
                                quantity: this.formData.quantity
                            }
                        }
                    }
                    this.loading = true;
                    this.invoke(data).then(res => {
                        if (!res) {
                            this.$Message.success('下单成功,请等待运营联系~')
                            this.loading = false;
                            this.onCancel()
                        }
                    }).catch(err => this.loading = false)
                }
            })
        }
    }

}
</script>

<style lang="scss" scoped>
</style>